var utils = {
    year:2022,
    IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {//IE11  
            if (version (userAgent)) { //window8 以及以上
                return true; 
            } else {
                return false
            }
        }else{
            return true;//不是ie浏览器
        }
    },
    version (version) {
        if (version.indexOf("Windows NT 5.0")!=-1 ) {
            return false
        } else if (version.indexOf("Windows NT 5.1")!=-1 ) {
            return false
        } else if (version.indexOf("Windows NT 5.2")!=-1 ) {
            return false
        } else if(version.indexOf("Windows NT 6.0")!=-1){
            return false
        } else if(version.indexOf("Windows NT 6.1")!=-1){
            return false
        } else if(version.indexOf("Windows NT 6.2")!=-1){
            return true
        } else if(version.indexOf("Windows NT 10.0")!=-1){
            return true
        }

    },
   rollList:[
        {'title':'重要通知',id:'28',url:'',date:'2022-12-30'},
        {'title':'关于辽宁省执业药师继续教育学习结束的通知',id:'27',url:'',date:'2022-12-05'},
        {'title':'2022年度辽宁省执业药师继续教育网上报名即将结束',id:'26',url:'',date:'2022-11-29'},
        {'title':'关于对学员网上学习过程加强管理的通知',id:'25',url:'',date:'2022-04-07'},
        {'title':'参加辽宁省执业药师学习必看的重要通知',id:'24',url:'',date:'2022-04-01'},
        {'title':'关于辽宁省执业药师继续教育平台网站域名升级变更的通知',id:'23',url:'',date:'2022-03-28'},
        {'title':'关于继续教育学分审核认定工作延期的通知',id:'22',url:'',date:'2022-03-23'},
        {'title':'关于加强对执业药师继续教育学习过程管理的通知',id:'21',url:'',date:'2022-03-22'},
        {'title':'2022年辽宁省执业药师继续教育网上培训正式启动',id:'20',url:'',date:'2022-03-10'},
        {'title':'关于2022年辽宁省执业药师继续教育公需科目学习的通知',id:'19',url:'',date:'2022-02-28'},
        {'title':'关于2022年辽宁省执业药师继续教育培训工作安排的通知',id:'18',url:'',date:'2022-02-28'},
        {'title':'关于调整执业药师继续教育收费标准的通知',id:'17',url:'',date:'2022-02-28'},
        {'title':'北京金航联科技发展有限公司简介',id:'7',url:'',date:'2022-03-01'},
        {'title':'关于辽宁省执业药师继续教育管理平台网址变更的通知',id:'16',url:'',date:'2022-02-17'},
        {'title':'关于辽宁省执业药师继续教育管理单位变更的通知',id:'15',url:'',date:'2022-01-05'},
        {'title':'关于2021年执业药师继续教育公需科目学习的通知',id:'14',url:'',date:'2021-08-04'},
        {'title':'图解｜《执业药师注册管理办法》',id:'',url:'https://mp.weixin.qq.com/s/H8CLYuCi23oxm0X6viaVsg',date:'2021-06-25'},
        // {'title':'关于2021年全省执业药师继续教育培训工作安排的通知',id:'13',url:'',date:'2021-02-04'},
        // {'title':'关于2020年全省执业药师继续教育培训工作安排的通知',id:'12',url:'',date:'2020-04-30'},
        // {'title':'关于调整执业药师继续教育收费标准的通知',id:'11',url:'',date:'2020-04-30'},
        // {'title':'关于开展2019年度《中国药师薪酬调研》活动的通知',id:'10',url:'',date:'2019-12-18'},
        // {'title':'关于变更执业药师继续教育学习方式的通知',id:'1',url:'',date:'2019-06-25'},
        // {'title':'关于2019年全省执业药师继续教育培训工作安排的通知',id:'2',url:'',date:'2019-03-12'},
        // {'title':'关于2018年全省执业药师继续教育培训工作安排的通知',id:'3',url:'',date:'2018-04-24'},
       
        // {'title':'关于学员开具发票必须填写纳税人识别号的通知',id:'4',url:'',date:'2017-02-24'},
        // {'title':'关于2017年全省执业药师继续教育培训工作安排的通知',id:'5',url:'',date:'2017-02-24'},
       
    ],
    
    formDate:{
        WorkName: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Sex:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        NATION:{
            'name':'民族','value':'',option:'NATION','showSelect':true,'select':
            ['汉族','少数民族','外籍'],
        },
        MEDULEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['药学','中药学','相关专业'],
        },
        sort: {
            'name':'证书类别','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师'],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学','药学和中药学'],
        },
        QualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        ATTEYEAR: {
            'name':'批准时间','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        zQualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zATTEYEAR: {
            'name':'中药证书批准时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        NATIVEPLACE: {
            'name': '执业地区','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
                '沈阳','大连','鞍山','抚顺','本溪','丹东','锦州','营口','阜新','辽阳','铁岭','朝阳','盘锦','葫芦岛','省外']
        },
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['生产','批发','零售','使用','机关','院校','检验','无'],
        },
        WorkUnit:{
            'name':'执业单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        zxsj:{
            'name':'注销时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        rdnf:{
            'name':'认定年份','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'技术职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','员级'],
        },
        JOBLEVEL:{
            'name':'现行政职务','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'E-mail','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        },
        byzpic:{
            'name':'毕业证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zgzpic:{
            'name':'资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        POLITICS:{
            'name':'政治面貌','value':'','placeholder':'请填写',option:'email','showSelect':true,'select':['党员',
        '团员','民主人士','群众']
        },
        zhuangtai:{
            'name':'执业状态','value':'','placeholder':'请填写',option:'email','showSelect':true,'select':[]
        },
        zcdw:{
            'name':'注册单位','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        zzzbh:{
            'name':'注册证号','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        REGISTERTIME: {
            'name':'注销时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        jg: {
            'name':'籍贯','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        stzw: {
            'name':'社团职务','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
      
      },
      isIE () {
            var userAgent = navigator.userAgent;
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
            if (isIE) {
                return true
            } else {
                return false
            }
    },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '面授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
        window.localStorage.clear();
      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      }
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js